/**
 * FeatureBullet — donkere card met emerald icoon + titel + 1 regel body.
 * Gebruikt voor "Wat Powersure doet" en "Top 3 kansen" overal in de app.
 */
import { psCls } from '@/lib/powersure-theme';

export default function FeatureBullet({ icon: Icon, title, body, testId, className = '' }) {
  return (
    <div
      className={`flex items-start gap-3 ${psCls.card} px-3.5 py-2.5 ${className}`}
      data-testid={testId}
    >
      <span className={psCls.iconBadgeSm}>
        {Icon ? <Icon className="w-4 h-4" /> : null}
      </span>
      <div className="min-w-0">
        <div className="text-sm font-medium text-white leading-tight">{title}</div>
        {body && (
          <div className="text-xs text-white/65 mt-0.5 leading-snug">{body}</div>
        )}
      </div>
    </div>
  );
}
